import React from "react";

export const TextArea = ({ content, showTooltip }) => {
  return (
    <div className="PioSolver__description">
      {showTooltip && (
        <div className="PioSolver__description-tooltip">
          Copied to clipboard!
        </div>
      )}
      <div>
        <h5 className="PioSolver__description-title">{content.title}</h5>
        <p className="PioSolver__description-subtitle">{content.sub_title}</p>
        <p className="PioSolver__description-text">{content.content}</p>
      </div>
    </div>
  );
};
